import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a freestanding kitchen range, 0.6 x 0.6 x 0.9 m: steel
// body lining up with the 0.9 worktop line, oven door with a dark window on
// +Z, black cooktop slab with four flat burner discs on top.
const STEEL = "#aab2b8";
const DOOR = "#b4bcc2";
const MATTE_BLACK = "#2e2e30";
const DARK_GLASS = "#3a3f44";

export const kitchenStove = defineModel({
  id: "kitchen-stove",
  batchId: "modern",
  name: "Kitchen stove",
  tags: ["modern", "interior", "appliance", "kitchen", "cooking", "stove"],
  summary: "A freestanding steel range with an oven door and a four-burner black cooktop.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.52, 0.08, 0.44), color: MATTE_BLACK, position: [0, 0.04, -0.04] },
      // body (back flush at z = -0.3, worktop-height top)
      { geometry: new THREE.BoxGeometry(0.6, 0.78, 0.56), color: STEEL, position: [0, 0.47, -0.02] },
      // oven door front
      { geometry: new THREE.BoxGeometry(0.54, 0.56, 0.03), color: DOOR, position: [0, 0.42, 0.275] },
      // dark oven window
      { geometry: new THREE.BoxGeometry(0.42, 0.3, 0.015), color: DARK_GLASS, position: [0, 0.4, 0.295] },
      // oven door handle bar
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.03), color: MATTE_BLACK, position: [0, 0.75, 0.315] },
      // black cooktop slab (top at 0.9)
      { geometry: new THREE.BoxGeometry(0.6, 0.04, 0.6), color: MATTE_BLACK, position: [0, 0.88, 0] },
      // four burner discs
      { geometry: new THREE.CylinderGeometry(0.09, 0.09, 0.015, 16), color: DARK_GLASS, position: [-0.14, 0.907, -0.14] },
      { geometry: new THREE.CylinderGeometry(0.09, 0.09, 0.015, 16), color: DARK_GLASS, position: [0.14, 0.907, -0.14] },
      { geometry: new THREE.CylinderGeometry(0.09, 0.09, 0.015, 16), color: DARK_GLASS, position: [-0.14, 0.907, 0.14] },
      { geometry: new THREE.CylinderGeometry(0.09, 0.09, 0.015, 16), color: DARK_GLASS, position: [0.14, 0.907, 0.14] },
    ];
  },
  animations: [],
});
